const tax_rate = 10;
const insurance_rate = 0.297 / 100;
// const insurance_rate = 0;

const calcul_pandi = (
    prixmaison,
    acompte,
    tauxdinteret,
    programmedepret
) => {

    return (
        ((prixmaison - acompte) * (tauxdinteret / 100 / 12)) /
        (1 - Math.pow(1 + tauxdinteret / 100 / 12, -programmedepret))
    );
};
export const calcul_interets = (prixmaison, acompte, tauxdinteret, programmedepret, period = 1) => {
    return (
        ((prixmaison - acompte) * (tauxdinteret / 1200) * (Math.pow((tauxdinteret / 1200 + 1), (programmedepret + 1)) - Math.pow((tauxdinteret / 1200 + 1), period))) /
        ((tauxdinteret / 1200 + 1) * (Math.pow((tauxdinteret / 1200 + 1), (programmedepret)) - 1))
    )
}

export const calcul_assurance = (prixmaison, acompte, insurance_rate, programmedepret, period = 1) => {
    return (
        ((prixmaison - acompte) * (insurance_rate / 1200) * (Math.pow((insurance_rate / 1200 + 1), (programmedepret + 1)) - Math.pow((insurance_rate / 1200 + 1), period))) /
        ((insurance_rate / 1200 + 1) * (Math.pow((insurance_rate / 1200 + 1), (programmedepret - 1))))
    )
}


export const courbes = (prixmaison, acompte, tauxdinteret, insurance_rate, programmedepret) => {

    let mensualite = calcul_pandi(prixmaison, acompte, tauxdinteret, programmedepret)
    let mensualites = [mensualite];
    let capital_restant = [prixmaison - acompte];
    let interets_cumules = [0];
    let principal_rembourse = [0];
    [...Array(programmedepret + 1).keys()].map(item => {
        mensualites = mensualites.concat([mensualite])
        let interets = calcul_interets(prixmaison, acompte, tauxdinteret, programmedepret, item + 1)
        interets_cumules = interets_cumules.concat([interets_cumules[interets_cumules.length - 1] + interets])
        let tva_sur_interets = interets * tax_rate / 100
        let assurances = calcul_assurance(prixmaison, acompte, insurance_rate, programmedepret, item + 1)
        capital_restant = capital_restant.concat([capital_restant[capital_restant.length - 1] - (mensualite - interets)])
        principal_rembourse = principal_rembourse.concat([principal_rembourse[principal_rembourse.length - 1] + (mensualite - interets)])
    })

    return ({
        mensualites: mensualites,
        capital_restant: capital_restant,
        interets_cumules: interets_cumules,
        principal_rembourse: principal_rembourse,
    })

}
export const update_courbes = (
    prixmaison,
    acompte,
    mensualite,
    programmedepret,
    tauxdinteret
) => {
    let tva = [];
    let interets = [];
    let interets_cumules = [0];
    let principal_rembourse = [0];
    let principal = [];
    let assurances = [];

    let capital_restant = [prixmaison - acompte];
    for (let i = 0; i < programmedepret; i++) {
        tva = tva.concat([
            (capital_restant[i] * (tax_rate / 100) * tauxdinteret) / 1200,
        ]);
        interets = interets.concat([(capital_restant[i] * tauxdinteret) / 1200]);
        interets_cumules = interets_cumules.concat([
            (capital_restant[i] * tauxdinteret) / 1200 + interets_cumules[i],
        ]);

        assurances = assurances.concat([
            (capital_restant[i] * insurance_rate) / 12,
        ]);

        principal = principal.concat([
            // mensualite - interets[i] - (interets[i] * tax_rate) / 100,
            mensualite - interets[i],
            // - assurances[i],
        ]);

        principal_rembourse = principal_rembourse.concat([
            principal_rembourse[i] + principal[i],
        ]);

        capital_restant = capital_restant.concat([
            capital_restant[i] - principal[i],
        ]);
    }

    return {
        tva: tva,
        principal_rembourse: principal_rembourse,
        interets_cumules: interets_cumules,
        interets: interets,
        principal: principal,
        assurances: assurances,
        capital_restant: capital_restant,
    };
};

export default calcul_pandi;